import React, { useContext, useState, useEffect } from "react";
import {
  Backdrop,
  Box,
  Button,
  Container,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import bkstApi from "../../common/api";
import ConfigContext from "../../common/context/ConfigContext";
import { Link as RouterLink } from "react-router-dom";
import Preview from "../../common/component/Preview";
import Contact from "../../common/component/Contact";
import EmblaCarousel from "../../common/component/carousel/EmblaCarousel";
import { Masonry } from "@mui/lab";
import { useParams } from "react-router-dom";

export default function CustomPage(props) {
  const siteConfig = useContext(ConfigContext);

  let { handle } = useParams();
  handle = handle || props.handle;

  const [page, setPage] = useState("");

  useEffect(() => {
    bkstApi(`/site/${siteConfig.id}/page/${handle}`).then((res) => {
      setPage(res.data.page);
    });
  }, [handle]);

  const getSection = (section) => {
    if (section.layout === "fullWidth") {
      if (section.media.type === "video") {
        return (
          <Box id={section.id} style={section.style || {}}>
            <Box
              position="relative"
              width="100vw"
              left="50%"
              right="50%"
              ml="-50vw"
              mr="-50vw"
              sx={{
                aspectRatio: "16/9",
                minHeight: { xs: 320, sm: 480, md: 600 },
                maxHeight: { xs: 480, sm: 600, md: 800 },
                background: "#111",
                overflow: "hidden",
              }}
            >
              <video
                src={section.media.src}
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: "100vw",
                  height: "100%",
                  objectFit: "contain",
                  background: "#111",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 1,
                }}
              />
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                zIndex={2}
                sx={{
                  background: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.25))",
                  color: "#fff",
                  textShadow: "0 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                <Typography
                  sx={{ fontSize: "calc(100% + 3vw)", fontWeight: "700", fontWeight: 700 }}
                >
                  {section.title}
                </Typography>
                <Typography sx={{ mt: 2, fontSize: "max(1rem, calc(80% + 1vw))" }}>
                  {section.subtitle}
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      } else if (section.media.type === "image") {
        return (
          <Box id={section.id} style={section.style || {}}>
            <Box
              position="relative"
              width="100vw"
              left="50%"
              right="50%"
              ml="-50vw"
              mr="-50vw"
              sx={{
                background: "#111",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                className="fullwidth-img"
                src={section.media.src}
                alt={section.title || ""}
                style={{
                  width: "100vw",
                  height: "auto",
                  display: "block",
                  objectFit: "contain",
                  objectPosition: "center center",
                }}
              />
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                zIndex={2}
                sx={{
                  background: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.25))",
                  color: "#fff",
                  textShadow: "0 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                <Typography
                  variant="h1"
                  style={{
                    color: section.color || "#fff",
                    fontSize: "calc(100% + 3vw)",
                    fontWeight: "700",
                  }}
                >
                  {section.title}
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{ color: section.color || "#fff", fontSize: "max(1rem, calc(80% + 1vw))" }}
                >
                  {section.subtitle}
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      }
    } else if (section.layout === "grid") {
      return (
        <Box
          id={section.id}
          sx={{
            flexDirection: {
              xs: section.parts[1]?.content ? "column" : "column-reverse",
              sm: "row",
            },
            ...(section.style || {}),
          }}
        >
          {section.parts.map((o, idx) => {
            if (o.content) {
              return (
                <Box sx={o.style || {}}>
                  <Box mb={2}>
                    <Typography
                      variant="h2"
                      sx={{ fontSize: "max(1.4rem, calc(100% + 1.8vw))" }}
                      gutterBottom
                    >
                      {o.title}
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary">
                      {o.subtitle}
                    </Typography>
                  </Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "justify" }}
                    dangerouslySetInnerHTML={{
                      __html: o.content,
                    }}
                  />
                  {section.cta && (
                    <Box mt={4} textAlign={"center"}>
                      <Button
                        component={RouterLink}
                        variant="contained"
                        color="primary"
                        to={section.cta.link}
                        size="large"
                        sx={{ fontSize: "24px" }}
                      >
                        {section.cta.title}
                      </Button>
                    </Box>
                  )}
                </Box>
              );
            } else if (o.media?.type === "image") {
              return (
                <Box sx={o.style || {}}>
                  <img
                    alt=""
                    style={{
                      width: "100%",
                      aspectRatio: "1",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                    src={o.media.src}
                  />
                </Box>
              );
            } else if (o.media?.type === "carousel") {
              return (
                <Box sx={o.style || {}}>
                  <EmblaCarousel
                    autoPlay={false}
                    infiniteLoop
                    interval={3000}
                    transitionTime={1500}
                    sx={{ aspectRatio: "1" }}
                  >
                    {o.media.src.map((pic, idx) => {
                      return (
                        <Box key={idx} sx={{ width: "100%", height: "100%" }}>
                          <img
                            alt={o.title}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                            src={pic}
                          />
                        </Box>
                      );
                    })}
                  </EmblaCarousel>
                </Box>
              );
            }
          })}
        </Box>
      );
    } else if (section.layout === "masonry") {
      return (
        <Box
          id={section.id}
          sx={{
            ...(section.style || {}),
          }}
        >
          <Masonry columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} spacing={2}>
            {section.parts.map((o, idx) => {
              if (o.media?.type === "image") {
                return (
                  <Box key={idx}>
                    <img
                      alt=""
                      style={{
                        width: "100%",
                        display: "block",
                        borderRadius: "4px",
                      }}
                      src={o.media.src}
                    />
                  </Box>
                );
              } else {
                return null;
              }
            })}
          </Masonry>
        </Box>
      );
    } else if (section.layout === "contact") {
      return (
        <Box id={section.id} style={section.style || {}}>
          <Grid container spacing={2}>
            <Grid item md={3} sm={2} xs={12}></Grid>
            <Grid item md={6} sm={8} xs={12}>
              <Box mb={2} textAlign="center">
                <Typography variant="h2" sx={{ fontSize: "calc(100% + 2.2vw)" }}>
                  {section.title}
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{ fontSize: "max(1rem, calc(75% + .75vw))" }}
                  color="textSecondary"
                >
                  {section.subtitle}
                </Typography>
              </Box>
              <Contact title={page.title || handle} />
            </Grid>
          </Grid>
        </Box>
      );
    }
  };

  if (page) {
    return (
      <Container maxWidth={page.maxWidth || "false"}>
        {page.title && page.sections?.[0]?.layout !== "fullWidth" && (
          <Box textAlign="center" my={6}>
            <Typography variant="h1" sx={{ fontSize: "calc(100% + 2.2vw)" }}>
              {page.title}
            </Typography>
            {page.subtitle && (
              <Typography
                variant="subtitle1"
                sx={{ fontSize: "max(1rem, calc(75% + .75vw))" }}
                color="textSecondary"
              >
                {page.subtitle}
              </Typography>
            )}
            {page.description && (
              <Typography variant="body1" color="textSecondary">
                {page.description}
              </Typography>
            )}
          </Box>
        )}
        {page.sections.map((section, idx) => {
          return getSection(section);
        })}
      </Container>
    );
  } else {
    return (
      <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
}
